import { Layout as BaseLayout } from "antd";
import { FC, Suspense, useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router";

import { SkeletonPage } from "@/components/SkeletonPage";

import { BreadcrumbsProvider } from "../Breadcrumbs/BreadcrumbsContext";
import { Header } from "./Header";
import { Sider } from "./Sider";

import "./index.less";

const AdminLayout: FC = () => {
  const location = useLocation();
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    contentRef.current?.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <BreadcrumbsProvider>
      <BaseLayout>
        <BaseLayout.Sider theme="light">
          <Sider />
        </BaseLayout.Sider>

        <BaseLayout>
          <BaseLayout.Header>
            <Header />
          </BaseLayout.Header>
          <BaseLayout.Content ref={contentRef}>
            <Suspense fallback={<SkeletonPage />}>
              <Outlet />
              <div id={"modal-container"} />
            </Suspense>
          </BaseLayout.Content>
        </BaseLayout>
      </BaseLayout>
    </BreadcrumbsProvider>
  );
};

export default AdminLayout;
